module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp1_8023.7acf3037.png";